


























import { Component } from 'vue-property-decorator'
import { EliteligaWidget } from '@russmedia-frontend/nordstern-eliteliga'
import type { SoccerLeague } from '@russmedia-frontend/nordstern-eliteliga'
import { ApolloOperationVariables } from '~base/common/types'
import EliteligaFeature from '~base/mixins/EliteligaFeature'
import VideoModal from '~components/eliteliga/VideoModal.vue'
import '@russmedia-frontend/nordstern-eliteliga/nordstern-eliteliga.css'

@Component<EliteligaUpcomingAndHighlightsWidget>({
  apollo: {
    multileague: {
      query: require('~base/graphql/queries/UpcomingAndHighlights.gql'),
      prefetch(): ApolloOperationVariables {
        return {
          leagues: this.leagues,
        }
      },
      variables(): ApolloOperationVariables {
        return {
          leagues: this.leagues,
        }
      },
    },
  },
  components: {
    EliteligaWidget,
    VideoModal,
  },
})
export default class EliteligaUpcomingAndHighlightsWidget extends EliteligaFeature {
  private multileague: SoccerLeague[] = []

  gotoSpecial() {
    this.$router.push(`/ressort/eliteliga`)
  }

  gotoMediathek() {
    this.$router.push(`/ressort/eliteliga/mediathek`)
  }
}
